setTimeout(function(){ 
    if(document.querySelector('.rc-widget')) {
        const node = document.querySelector('.rc-template__radio');
        const oneTimeElement = node.querySelector('.onetime-radio');
        const textnode = document.createElement('div');
        textnode.classList.add('text-subscription')
        textnode.innerHTML = '<span>Monthly Subscription <span style="color:red;font-size: 12px;">(minimum 3 months subscription*)</span></span><span>Auto Delivery</span><span>Edit Your Subscription</span><span>Keep Your Pet Protected</span>'
        node.insertBefore(textnode, oneTimeElement);
        const textLabel = document.createElement('div');
        textLabel.classList.add('text-subscription-label')
        textLabel.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="10" fill="#FF784A"/><circle cx="10" cy="10" r="3" fill="white"/></svg><span>Subscribe & Save</span>'
        node.insertBefore(textLabel, textnode);
    }
}, 1000);

if(document.querySelector('.recharge-subscription-widget [data-v-app]')) {
    const rechargeMain = document.querySelector('.recharge-subscription-widget');
    const rcWidget = rechargeMain.querySelector('div[data-v-app]');
    const labelWidget = document.createElement('label');
    labelWidget.classList.add('field--label', 'rc-label');
    labelWidget.innerHTML = 'Frequency:'
    rechargeMain.insertBefore(labelWidget, rcWidget);
}

